module.exports = __webpack_public_path__ + "./images/tier6.jpg";